import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable } from 'rxjs';
import { OrganizationService } from './organization.service';

@Injectable({
  providedIn: 'root',
})
export class AppSignalRService {
  private hubConnection: signalR.HubConnection | null = null;

  constructor(private organizationService: OrganizationService) {
    this.createConnection();
  }

  createConnection() {
    const hubUrl = this.organizationService.getHubUrl();
    if (this.hubConnection) {
      this.hubConnection.stop().catch(() => {});
    }
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withAutomaticReconnect()
      .withUrl(hubUrl, { accessTokenFactory: () => { 
        console.log('hub getting token from accessTokenFactory');
        return localStorage.getItem("id_token") || "" 
      } }) // SignalR hub URL
      .build();
  }

  startConnection(): Observable<void> {
    return new Observable<void>((observer) => {
      if (!this.hubConnection) {
        this.createConnection();
      }
      this.hubConnection!
        .start()
        .then(() => {
          console.log('Connection established with SignalR hub');
          observer.next();
          observer.complete();
        })
        .catch((error) => {
          console.error('Error connecting to SignalR hub:', error);
          observer.error(error);
        });
    });
  }

  stopConnection(): void { 
    if (this.hubConnection) {
      this.hubConnection.stop()
        .then(() => { console.log('Connection stopped with SignalR hub'); })
        .catch((error) => { console.error('Error stopping SignalR hub:', error); });
    }
  }

  receiveMessage(): Observable<string> {
    return new Observable<string>((observer) => {
      if (this.hubConnection) {
        this.hubConnection.on('ReceiveMessage', (message: string) => {
          observer.next(message);
        });
      }
    });
  }

  // trips should be reloaded
  reloadTrips(): Observable<string> {
    return new Observable<string>((observer) => {
      if (this.hubConnection) {
        this.hubConnection.on('ReloadTrips', (message: string) => {
          observer.next(message);
        });
      }
    });
  }  

  sendMessage(message: string): void {
    if (this.hubConnection) {
      this.hubConnection.invoke('SendMessage', message);
    }
  }
}